import React from 'react';
import './About.css';

import foto from '../../assets/sophia1.jpg';
import zertifikat from '../../assets/zertifikat.jpg';

export const About = () => {
    return (
        <section id='about'>
            <div className='text-card-container'>
                <h3 className="hero-heading">In der Klarheit wird deine innere Stimme hörbar. Verwurzelt findest du den Mut, ihr zu folgen – und das, was sie dir zeigt, in die Welt zu bringen.</h3>                <br />
                <div className="row g-5">

                    {/* Linke Spalte: Foto */}
                    <div className="col-sm-4">
                        <img style={{ width: '100%' }} src={foto} alt="Sophia" />
                        {/* <div className="image-copyright">© beans</div> */}
                    </div>

                    {/* Rechte Spalte: Text */}
                    <div className="col-sm-8">




                        <p className="lead-text">Ich bin Sophia und unterrichte Kundalini Yoga in München.</p>

                        <p className="lead-text">
                            Yoga bedeutet Verbindung. Eine Rückverbindung zu deiner inneren Stimme, die im Lärm des Alltags oft leise wird.
                        </p><p className="lead-text">
                            Kundalini Yoga öffnet den Raum für Intuition und schenkt gleichzeitig die Verwurzelung, aus ihr heraus zu handeln.
                        </p>

                        <p className="lead-text">
                            So entsteht Gestaltungskraft. Nicht nur als künstlerischer Ausdruck, sondern als die Fähigkeit, das eigene Leben bewusst, mutig und intuitiv zu gestalten.
                        </p>

                        <br />

                        <h4>Warum Kundalini Yoga?</h4>
                        <p>
                            Wir alle kennen Sätze wie:
                            <em> „Hör auf deine Intuition.“</em>,
                            <em> „Vertrau dir.“</em> oder
                            <em> „Du bist nicht deine Gedanken.“</em><br />
                            Doch wenn unser Nervensystem im Stress ist, reicht dieses Wissen oft nicht aus.
                        </p>
                        <p>
                            Lange habe ich versucht, meinen Kopf mit noch mehr Gedanken zu beruhigen. Ich dachte, ich müsste nur lernen, anders zu denken. Erst durch Kundalini Yoga habe ich eine Praxis gefunden, die mich zuverlässig zurück in Verbindung bringt.
                        </p>
                        <p>
                            Durch Bewegung, Atem, Mantren und Meditation wird der innere Lärm leiser. Nicht, damit nichts mehr da ist. Sondern damit wieder hörbar wird, was schon die ganze Zeit da war.
                        </p>
                        <br />

                        <h4>Gestaltungskraft beginnt mit Verbindung</h4>
                        <blockquote className="about-quote">
                            "Art is not about thinking something up. It is about getting something down."
                            <cite>– Julia Cameron (The Artist's Way)</cite>
                        </blockquote>

                        <p>
                            Dieser Satz beschreibt für mich nicht nur Kunst, sondern Leben. Ich glaube nicht, dass Kreativität etwas ist, das wir produzieren. Sie möchte durch uns entstehen. Ideen sind selten das Schwierige. Das Schwierige ist, ihnen zu vertrauen.
                        </p>
                        <p>
                            Spiritualität bedeutet für mich deshalb nicht, mich aus der Welt zurückzuziehen. Sondern mich so tief mit mir selbst zu verbinden, dass ich beginnen kann, die Welt aus dieser Verbindung heraus zu gestalten. Wie Michelangelo sagte: Die Statue war bereits im Stein. Sie musste nicht erschaffen werden, sondern freigelegt. So verstehe ich auch Yoga. Es erinnert uns daran, wer wir sind. Und lädt uns ein, genau daraus zu leben.
                        </p>
                        <br />

                        <h4>Mein Weg</h4>
                        <p>
                            Ich begann intensiver Yoga zu praktizieren, weil ich besser mit Stress umgehen wollte. Doch statt einfach belastbarer zu werden, wurde ich klarer. Klarer darin, wer ich bin, was mir wichtig ist und welchen Weg ich wirklich gehen möchte.
                        </p>
                        <p>
                            Diese Klarheit führte mich dazu, meine Festanstellung im IT-Unternehmen zu verlassen und mich in die Selbstständigkeit zu wagen, <a href="https://www.mondwild.com" target="_blank" rel="noopener noreferrer">meinen Traum als Musikerin zu verfolgen</a> und eine Ausbildung zur Kundalini-Yogalehrerin zu machen.
                        </p>
                        <p>
                            Bis heute begleitet mich diese Praxis jeden Tag. Nicht, weil sie das Leben einfacher macht. Sondern weil sie mich immer wieder mit mir selbst verbindet. Genau diesen Raum möchte ich heute auch für andere öffnen.
                        </p>
                        <br />

                        <h4>Zur Tradition</h4>
                        <p>
                            Ich unterrichte Kundalini Yoga in der Tradition „Kundalini Yoga as taught by Yogi Bhajan“, wie ich sie bei Mitali und Robert Chatterjee Ehrenbrand gelernt habe. Gleichzeitig distanziere ich mich klar von Yogi Bhajan. Im Mittelpunkt meines Unterrichts stehen nicht Guruverehrung oder Dogmen, sondern deine eigene Erfahrung und die Verbindung zu deiner inneren Wahrheit.
                        </p>
                        <br />

                        <h4>Ausbildung</h4>
                        <table>
                            <tbody>
                                <tr>
                                    <td>2015 bis heute</td>
                                    <td>Regelmäßige Yoga-Praxis</td>
                                </tr>
                                <tr>
                                    <td>Januar bis März 2026</td>
                                    <td>200+ Stunden Ausbildung zur Kundalini-Yogalehrerin bei Mitali und Robert Chatterjee Ehrenbrand im Patrick Broome Yoga Studio in München</td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="certificate-container">
                            <img
                                src={zertifikat}
                                alt="Ausbildungszertifikat Kundalini Yoga"
                                className="certificate-img"
                            />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}